module.exports = __webpack_public_path__ + "static/media/icon_jin6541c643368974c4bde5b27144a1248f.webp";